import React from "react";

import { Text, TextProps } from "@chakra-ui/react";
import { theme } from "@ovou-inc/ovou-ui";

// "Move or pinch the photo to adjust. / Or use the slider." — rendered above
// the footer buttons on tall viewports (via UploadPreviewModal) and at the end
// of the scrollable panel on compact viewports (via CropPanel). Extracted into
// its own component so the styling stays in one place.
const CropHelperText: React.FC<TextProps> = props => (
  <Text
    fontSize="12px"
    color={theme.palette.ui.greys.grey1}
    textAlign="center"
    lineHeight="150%"
    fontWeight={400}
    {...props}
  >
    Move or pinch the photo to adjust.
    <br />
    Or use the slider.
  </Text>
);

export default CropHelperText;
